export const siteMetadata = {
  title: 'Robocat Casino Erfahrungen 2025 - Vollständige Bewertung',
  description: 'Robocat Casino Bewertung für Deutschland ⚡ Willkommensbonus 500€ + 200 Freispiele ✓ Über 3000 Spiele ✓ Schnelle Auszahlung ✓ Lizenziert & Sicher',
  keywords: 'robocat casino, robocat erfahrungen, robocat bewertung, robocat casino deutschland'
};

export const logo = 'https://bonkku.com/wp-content/uploads/2024/11/robocat-casino-logo-e1730983673466.png';

export const heroImages = {
  main: 'https://images.unsplash.com/photo-1707075891514-9d271023f384?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwY2FzaW5vfGVufDB8fHx8MTc2MjY0OTQ0Mnww&ixlib=rb-4.1.0&q=85',
  games: 'https://images.unsplash.com/photo-1552749412-7bbae756acfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxmdXR1cmlzdGljJTIwY2FzaW5vfGVufDB8fHx8MTc2MjY0OTQ0Mnww&ixlib=rb-4.1.0&q=85',
  trust: 'https://images.unsplash.com/photo-1759178389249-13274fe80509?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxmdXR1cmlzdGljJTIwY2FzaW5vfGVufDB8fHx8MTc2MjY0OTQ0Mnww&ixlib=rb-4.1.0&q=85'
};

export const navigation = [
  { name: 'RoboCat', path: '/' },
  { name: 'Aktionen', path: '/aktionen' },
  { name: 'Spiele', path: '/spiele' },
  { name: 'Registrieren', path: '/registrieren' },
  { name: 'App', path: '/app' },
  { name: 'Über uns', path: '/ueber-uns' }
];

export const bonuses = [
  {
    id: 1,
    title: 'Willkommensbonus',
    amount: '100% bis zu 500 €',
    extras: '200 FS + 1 Bonus Crab',
    description: 'Der großzügige Willkommensbonus bietet Ihnen die perfekte Grundlage für Ihr Spielerlebnis bei Robocat Casino. Verdoppeln Sie Ihre erste Einzahlung bis zu 500 € und erhalten Sie zusätzlich 200 Freispiele sowie einen exklusiven Bonus Crab.',
    requirements: 'Mindesteinzahlung: 20 €, Umsatzbedingungen: 35x',
    validUntil: '31.12.2025',
    featured: true
  },
  {
    id: 2,
    title: 'Ersteinzahlungsbonus',
    amount: '100% bis zu 200 €',
    extras: '',
    description: 'Verdoppeln Sie Ihre erste Einzahlung mit unserem exklusiven Ersteinzahlungsbonus. Perfekt für neue Spieler, die das Casino mit zusätzlichem Guthaben erkunden möchten.',
    requirements: 'Mindesteinzahlung: 10 €, Umsatzbedingungen: 30x',
    validUntil: '31.12.2025',
    featured: false
  },
  {
    id: 3,
    title: 'Roulette Rennen',
    amount: '8.000 €',
    extras: 'Preispool',
    description: 'Nehmen Sie am spannenden Roulette Rennen teil und sichern Sie sich Ihren Anteil am 8.000 € Preispool. Jeden Monat neue Gewinnchancen für alle Roulette-Fans.',
    requirements: 'Teilnahme automatisch bei Roulette-Spielen',
    validUntil: 'Monatlich',
    featured: false
  },
  {
    id: 4,
    title: 'Mega Roulette 3000',
    amount: '250.000 €',
    extras: 'Jackpot',
    description: 'Der größte Roulette-Jackpot wartet auf Sie! Mega Roulette 3000 bietet unglaubliche 250.000 € Gewinnpotenzial. Spielen Sie mit und werden Sie zum Millionär.',
    requirements: 'Mindesteinsatz pro Runde: 5 €',
    validUntil: 'Dauerhaft',
    featured: true
  }
];

export const games = [
  {
    id: 1,
    name: 'Gates of Olympus Super Scatter',
    provider: 'Pragmatic Play',
    rtp: '96.50%',
    rating: 4.8,
    type: 'Slot',
    volatility: 'Hoch',
    description: 'Tauchen Sie ein in die mythologische Welt des Olymps mit diesem hochvolatilen Slot von Pragmatic Play. Super Scatter Features und Multiplikatoren bis zu 500x sorgen für explosive Gewinne.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/r4g9tmlg_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.59.26.png'
  },
  {
    id: 2,
    name: 'Wild Wins 40',
    provider: 'Fazi',
    rtp: '96.20%',
    rating: 4.5,
    type: 'Slot',
    volatility: 'Mittel',
    description: 'Klassischer Slot mit modernem Twist. 40 Gewinnlinien und expandierende Wilds bieten konstante Gewinnchancen für Einsteiger und erfahrene Spieler.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/u3d11skm_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.00.03.png'
  },
  {
    id: 3,
    name: 'Gold Saloon Roulette',
    provider: 'Evolution',
    rtp: '97.30%',
    rating: 4.9,
    type: 'Live Casino',
    volatility: 'Niedrig',
    description: 'Erleben Sie das authentische Casino-Gefühl mit Evolution\'s Gold Saloon Roulette. Professionelle Dealer und HD-Streaming für das ultimative Live-Erlebnis.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/0k6gk554_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.01.40.png'
  },
  {
    id: 4,
    name: 'Sweet Bonanza 1000',
    provider: 'Pragmatic Play',
    rtp: '96.51%',
    rating: 4.7,
    type: 'Slot',
    volatility: 'Sehr Hoch',
    description: 'Die legendäre Sweet Bonanza Serie kehrt mit noch größeren Multiplikatoren zurück. Bis zu 1000x Gewinnpotenzial und Tumble-Features für endlose Gewinnkombinationen.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/vadu6eat_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2007.59.12.png'
  },
  {
    id: 5,
    name: 'The Luxe',
    provider: 'Hacksaw Gaming',
    rtp: '96.26%',
    rating: 4.6,
    type: 'Slot',
    volatility: 'Hoch',
    description: 'Luxus und Eleganz treffen auf spannende Gameplay-Mechaniken. Hacksaw Gaming\'s The Luxe bietet einzigartige Features und beeindruckende visuelle Effekte.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/rhfumj4q_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2008.00.32.png'
  },
  {
    id: 6,
    name: 'Legacy of Dead',
    provider: 'Play\'n GO',
    rtp: '96.58%',
    rating: 4.8,
    type: 'Slot',
    volatility: 'Sehr Hoch',
    description: 'Folgen Sie den Spuren berühmter Abenteurer im alten Ägypten. Expanding Symbols und Freispiel-Features mit hohem Gewinnpotenzial machen diesen Slot zu einem echten Klassiker.',
    image: 'https://customer-assets.emergentagent.com/job_seo-casino-portal-1/artifacts/negqzk2y_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-11-09%20%D0%B2%2008.02.14.png'
  }
];

export const paymentMethods = [
  { name: 'Visa', processingTime: 'Sofort', limit: '10 € - 5.000 €' },
  { name: 'Mastercard', processingTime: 'Sofort', limit: '10 € - 5.000 €' },
  { name: 'Sofortüberweisung', processingTime: 'Sofort', limit: '20 € - 10.000 €' },
  { name: 'PayPal', processingTime: 'Sofort', limit: '10 € - 3.000 €' },
  { name: 'Neteller', processingTime: '1-2 Stunden', limit: '10 € - 5.000 €' },
  { name: 'Skrill', processingTime: '1-2 Stunden', limit: '10 € - 5.000 €' },
  { name: 'Paysafecard', processingTime: 'Sofort', limit: '10 € - 1.000 €' },
  { name: 'Banküberweisung', processingTime: '3-5 Werktage', limit: '50 € - 50.000 €' },
  { name: 'Bitcoin', processingTime: '15-30 Minuten', limit: '20 € - 10.000 €' }
];

export const faqs = {
  homepage: [
    {
      question: 'Ist Robocat Casino in Deutschland legal?',
      answer: 'Ja, Robocat Casino operiert mit einer gültigen internationalen Glücksspiellizenz und bietet deutschen Spielern einen sicheren und regulierten Zugang zu Online-Casino-Spielen. Die Plattform erfüllt alle erforderlichen Sicherheitsstandards und bietet verantwortungsvolles Spielen.'
    },
    {
      question: 'Welchen Willkommensbonus bietet Robocat Casino?',
      answer: 'Neue Spieler erhalten einen großzügigen Willkommensbonus von 100% bis zu 500 € plus 200 Freispiele und einen Bonus Crab. Zusätzlich gibt es einen Ersteinzahlungsbonus von 100% bis zu 200 € für noch mehr Spielspaß.'
    },
    {
      question: 'Wie schnell erfolgen Auszahlungen bei Robocat Casino?',
      answer: 'Die Auszahlungsgeschwindigkeit hängt von der gewählten Zahlungsmethode ab. E-Wallets wie PayPal, Neteller und Skrill werden innerhalb von 1-2 Stunden bearbeitet, während Kreditkarten und Sofortüberweisung bis zu 24 Stunden dauern können. Banküberweisungen benötigen 3-5 Werktage.'
    },
    {
      question: 'Welche Spiele sind bei Robocat Casino verfügbar?',
      answer: 'Robocat Casino bietet über 3.000 Spiele von Top-Anbietern wie Pragmatic Play, Evolution, Play\'n GO, Hacksaw Gaming und Fazi. Das Portfolio umfasst Slots, Live-Casino-Spiele, Tischspiele, Roulette und progressive Jackpots.'
    },
    {
      question: 'Benötige ich einen Bonus Code bei Robocat Casino?',
      answer: 'Nein, für die meisten Aktionen bei Robocat Casino wird kein Bonus Code benötigt. Die Boni werden automatisch nach der Registrierung und Einzahlung Ihrem Konto gutgeschrieben. Spezielle Promo-Codes werden bei zeitlich begrenzten Aktionen per E-Mail oder auf der Aktionsseite kommuniziert.'
    }
  ],
  aktionen: [
    {
      question: 'Wie aktiviere ich meinen Willkommensbonus?',
      answer: 'Der Willkommensbonus wird automatisch bei Ihrer ersten Einzahlung aktiviert. Registrieren Sie sich, tätigen Sie eine Mindesteinzahlung von 20 € und der Bonus wird sofort Ihrem Konto gutgeschrieben. Die 200 Freispiele werden in Tranchen über mehrere Tage verteilt.'
    },
    {
      question: 'Was sind die Umsatzbedingungen für Boni?',
      answer: 'Der Willkommensbonus hat eine 35-fache Umsatzbedingung, während der Ersteinzahlungsbonus 30-fach umgesetzt werden muss. Das bedeutet, Sie müssen den Bonusbetrag entsprechend oft einsetzen, bevor eine Auszahlung möglich ist. Freispielgewinne unterliegen einer 40-fachen Umsatzanforderung.'
    },
    {
      question: 'Gibt es einen Bonus ohne Einzahlung bei Robocat Casino?',
      answer: 'Aktuell bietet Robocat Casino keinen klassischen Bonus ohne Einzahlung an. Jedoch erhalten Neukunden nach der Registrierung Zugang zu exklusiven Demo-Spielen und können das Casino risikofrei testen. Spezielle No-Deposit-Aktionen werden gelegentlich für Bestandskunden angeboten.'
    },
    {
      question: 'Kann ich mehrere Boni gleichzeitig nutzen?',
      answer: 'Nein, bei Robocat Casino kann immer nur ein Bonus gleichzeitig aktiv sein. Sie müssen die Umsatzbedingungen Ihres aktuellen Bonus erfüllen oder diesen abbrechen, bevor Sie einen neuen Bonus aktivieren können. Dies stellt faire Spielbedingungen für alle Spieler sicher.'
    }
  ],
  spiele: [
    {
      question: 'Welche Spieleanbieter sind bei Robocat Casino verfügbar?',
      answer: 'Robocat Casino arbeitet mit über 50 renommierten Spieleanbietern zusammen, darunter Pragmatic Play, Evolution Gaming, Play\'n GO, Hacksaw Gaming, Fazi, NetEnt, Microgaming, Yggdrasil und viele mehr. Dies garantiert eine vielfältige Auswahl an hochwertigen Spielen.'
    },
    {
      question: 'Was bedeutet RTP bei Slots?',
      answer: 'RTP (Return to Player) gibt an, welcher Prozentsatz der Einsätze langfristig an die Spieler zurückgezahlt wird. Ein RTP von 96% bedeutet, dass von 100 € Einsatz durchschnittlich 96 € wieder ausgezahlt werden. Je höher der RTP, desto besser die theoretischen Gewinnchancen.'
    },
    {
      question: 'Kann ich Spiele kostenlos testen?',
      answer: 'Ja, die meisten Slots und Tischspiele bei Robocat Casino können im Demo-Modus kostenlos getestet werden. So können Sie die Spiele und ihre Features kennenlernen, bevor Sie mit Echtgeld spielen. Nur Live-Casino-Spiele erfordern zwingend Echtgeldeinsätze.'
    },
    {
      question: 'Was sind die beliebtesten Slots bei Robocat Casino?',
      answer: 'Zu den Top-Favoriten gehören Gates of Olympus Super Scatter, Sweet Bonanza 1000, Legacy of Dead und The Luxe. Diese Spiele überzeugen durch hohe RTP-Werte, spannende Features und großes Gewinnpotenzial mit Multiplikatoren bis zu 1000x.'
    }
  ],
  registrieren: [
    {
      question: 'Wie registriere ich mich bei Robocat Casino?',
      answer: 'Klicken Sie auf den "Registrieren" Button, geben Sie Ihre persönlichen Daten (Name, E-Mail, Geburtsdatum) ein und erstellen Sie ein sicheres Passwort. Nach der Bestätigung Ihrer E-Mail-Adresse ist Ihr Konto sofort einsatzbereit und Sie können Ihre erste Einzahlung tätigen.'
    },
    {
      question: 'Welche Dokumente werden für die Verifizierung benötigt?',
      answer: 'Für die Kontoverifizierung benötigen Sie einen gültigen Lichtbildausweis (Personalausweis oder Reisepass) und einen Adressnachweis (Stromrechnung oder Kontoauszug), der nicht älter als 3 Monate ist. Die Verifizierung erfolgt schnell und sicher über den verschlüsselten Upload-Bereich.'
    },
    {
      question: 'Ab welchem Alter darf ich bei Robocat Casino spielen?',
      answer: 'Das Mindestalter für die Registrierung und das Spielen bei Robocat Casino beträgt 18 Jahre. Bei der Anmeldung und spätestens vor der ersten Auszahlung wird Ihr Alter durch Dokumente überprüft. Minderjährige sind vom Spielen ausgeschlossen.'
    },
    {
      question: 'Kann ich mehrere Konten erstellen?',
      answer: 'Nein, pro Person ist nur ein Konto bei Robocat Casino erlaubt. Mehrfachkonten verstoßen gegen die Nutzungsbedingungen und können zur Sperrung aller Konten und Verwirkung von Guthaben und Gewinnen führen. Verwenden Sie immer nur Ihr persönliches Konto.'
    }
  ],
  app: [
    {
      question: 'Gibt es eine Robocat Casino App zum Download?',
      answer: 'Robocat Casino bietet keine native App für iOS oder Android an. Stattdessen können Sie die optimierte mobile Website nutzen, die über jeden Browser zugänglich ist und alle Funktionen der Desktop-Version bietet. Einfach im Browser öffnen und losspielen!'
    },
    {
      question: 'Wie füge ich Robocat Casino zum Homescreen hinzu?',
      answer: 'Auf iOS: Öffnen Sie die Website in Safari, tippen Sie auf das Teilen-Symbol und wählen Sie "Zum Home-Bildschirm". Auf Android: Öffnen Sie die Website in Chrome, tippen Sie auf die drei Punkte und wählen Sie "Zum Startbildschirm hinzufügen". So haben Sie direkten Zugriff wie bei einer App.'
    },
    {
      question: 'Funktionieren alle Spiele auf dem Smartphone?',
      answer: 'Ja, über 95% aller Spiele bei Robocat Casino sind vollständig für mobile Geräte optimiert. Slots, Tischspiele und Live-Casino-Spiele laufen reibungslos auf iOS und Android. Lediglich einige ältere Spiele sind möglicherweise nur auf dem Desktop verfügbar.'
    },
    {
      question: 'Sind mobile Einzahlungen und Auszahlungen möglich?',
      answer: 'Absolut! Alle Zahlungsmethoden, die auf der Desktop-Version verfügbar sind, funktionieren auch mobil. Sie können Ein- und Auszahlungen sicher über Ihr Smartphone oder Tablet vornehmen. Die mobile Version bietet dieselbe Sicherheit und Verschlüsselung wie die Desktop-Version.'
    }
  ],
  auszahlung: [
    {
      question: 'Wie lange dauert eine Auszahlung bei Robocat Casino?',
      answer: 'Die Bearbeitungszeit beträgt in der Regel 24 Stunden. E-Wallets (PayPal, Neteller, Skrill) werden am schnellsten ausgezahlt (1-2 Stunden), gefolgt von Kreditkarten (1-3 Tage) und Banküberweisungen (3-5 Werktage). Verifizierte Konten werden prioritär behandelt.'
    },
    {
      question: 'Gibt es Auszahlungslimits bei Robocat Casino?',
      answer: 'Die Mindestauszahlung beträgt 20 €. Die maximale Auszahlung pro Transaktion liegt bei 5.000 € für die meisten Zahlungsmethoden. Größere Gewinne können in mehreren Transaktionen ausgezahlt werden. VIP-Spieler profitieren von höheren Limits und bevorzugter Bearbeitung.'
    },
    {
      question: 'Fallen Gebühren für Auszahlungen an?',
      answer: 'Robocat Casino erhebt keine Gebühren für Auszahlungen. Allerdings können Ihre Bank oder Ihr Zahlungsdienstleister eigene Gebühren verlangen. Die ersten 3 Auszahlungen pro Monat sind garantiert kostenfrei, danach kann eine Bearbeitungsgebühr von 2,5% anfallen.'
    },
    {
      question: 'Warum wurde meine Auszahlung abgelehnt?',
      answer: 'Häufige Gründe sind: unvollständige Kontoverifizierung, nicht erfüllte Bonusbedingungen, Verwendung einer anderen Zahlungsmethode als bei der Einzahlung, oder unzureichende Dokumentation. Prüfen Sie Ihr E-Mail-Postfach für Details und kontaktieren Sie bei Fragen den Support.'
    }
  ]
};

export const advantages = [
  {
    title: 'Lizenziert & Sicher',
    description: 'Robocat Casino operiert mit gültiger Glücksspiellizenz und verwendet modernste SSL-Verschlüsselung zum Schutz Ihrer Daten.',
    icon: 'Shield'
  },
  {
    title: 'Über 3.000 Spiele',
    description: 'Riesige Auswahl an Slots, Live-Casino, Tischspielen und Jackpots von Top-Anbietern wie Pragmatic Play, Evolution und Play\'n GO.',
    icon: 'Gamepad2'
  },
  {
    title: 'Schnelle Auszahlungen',
    description: 'Blitzschnelle Auszahlungen innerhalb von 1-24 Stunden mit E-Wallets, Kreditkarten und Kryptowährungen.',
    icon: 'Zap'
  },
  {
    title: 'Großzügige Boni',
    description: 'Willkommensbonus bis zu 500 € + 200 Freispiele sowie regelmäßige Aktionen und Turniere mit hohen Preispools.',
    icon: 'Gift'
  },
  {
    title: '24/7 Kundensupport',
    description: 'Professioneller deutschsprachiger Support per Live-Chat, E-Mail und Telefon - rund um die Uhr für Sie erreichbar.',
    icon: 'Headphones'
  },
  {
    title: 'Mobile Optimiert',
    description: 'Spielen Sie überall und jederzeit mit der perfekt optimierten mobilen Version für iOS und Android Geräte.',
    icon: 'Smartphone'
  }
];

export const trustBadges = [
  '18+ Verantwortungsbewusstes Spielen',
  'SSL-Verschlüsselung',
  'Lizenziert & Reguliert',
  'Faire Spielbedingungen',
  'Datenschutz DSGVO-konform'
];

export const footerLinks = {
  legal: [
    { name: 'Datenschutz', path: '/datenschutz' },
    { name: 'AGB', path: '/agb' },
    { name: 'Impressum', path: '/impressum' },
    { name: 'Verantwortungsvolles Spielen', path: '/verantwortungsvolles-spielen' }
  ],
  support: [
    { name: 'Kontakt', path: '/kontakt' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Zahlungsmethoden', path: '/zahlungsmethoden' },
    { name: 'Bonusbedingungen', path: '/bonusbedingungen' }
  ]
};
